import axios from "axios";
import { userEmail } from "../../Common/Store/CommonSignals";

const serializeTilesForBackend = (tiles, treeViewConfigs = {}) => {
  return tiles.map((tile) => ({
    id: tile.id,
    header: tile.header,
    body: JSON.stringify(treeViewConfigs[tile.id] || { treeViews: [], itemOrder: {} }),
    defaultPosition: {
      col: tile.defaultPosition.col,
      colSpan: tile.defaultPosition.colSpan,
      rowSpan: tile.defaultPosition.rowSpan,
    },
  }));
};

const deserializeTilesFromBackend = (tiles) => {
  if (!tiles || !Array.isArray(tiles)) return { tiles: [], treeViewConfigs: {} };

  const treeViewConfigs = {};
  const deserializedTiles = tiles.map((tile) => {
    const tileId = parseInt(tile.id);

    // Parse treeViewConfig from body
    try {
      if (tile.body && tile.body.trim() !== "") {
        treeViewConfigs[tileId] = JSON.parse(tile.body);
      } else {
        treeViewConfigs[tileId] = { treeViews: [], itemOrder: {} };
      }
    } catch (e) {
      console.error("Failed to parse treeViewConfig from body for tile", tileId, e);
      treeViewConfigs[tileId] = { treeViews: [], itemOrder: {} };
    }

    return {
      id: tileId,
      header: tile.header,
      body: "",
      defaultPosition: {
        col: tile.defaultPosition?.col || 1,
        colSpan: tile.defaultPosition?.colSpan || 1,
        rowSpan: tile.defaultPosition?.rowSpan || 1,
      },
      resizable: true,
      reorderable: true,
    };
  });

  return { tiles: deserializedTiles, treeViewConfigs };
};

export const homepageService = {
  // Load all dashboards for the current user
  async loadAllDashboards() {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT}/api/dashboard/user/${encodeURIComponent(
          userEmail.value
        )}`
      );

      const dashboards = response.data;

      if (!Array.isArray(dashboards) || dashboards.length === 0) {
        return [];
      }

      // Deserialize each dashboard
      return dashboards.map((dashboard) => {
        const { tiles: deserializedTiles, treeViewConfigs } = deserializeTilesFromBackend(
          dashboard.tiles || []
        );

        return {
          id: dashboard.id,
          name: dashboard.dashboardName || "Dashboard",
          tiles: deserializedTiles,
          treeViewConfigs,
          isLocked: true, // Default to locked when loading
        };
      });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return [];
      }
      throw error;
    }
  },

  // Save a single dashboard
  async saveDashboard(dashboard) {
    console.log("Saving dashboard", dashboard);

    const serializedTiles = serializeTilesForBackend(dashboard.tiles, dashboard.treeViewConfigs);

    const payload = {
      id: dashboard.id,
      tiles: serializedTiles,
      userEmail: userEmail.value,
      dashboardName: dashboard.name,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/api/dashboard?userEmail=${encodeURIComponent(
        userEmail.value
      )}`,
      payload
    );

    return response.data;
  },

  // Delete a dashboard
  async deleteDashboard(dashboardId) {
    console.log("Deleting dashboard", dashboardId);

    const response = await axios.delete(
      `${
        process.env.REACT_APP_API_ENDPOINT
      }/api/dashboard/${dashboardId}?userEmail=${encodeURIComponent(userEmail.value)}`
    );

    return response.data;
  },
};
